import { PageCard } from "@common/components/layout/";
import { Pager } from "@common/components/pagination";
import { useApp } from '@common/hooks';
import { UserSearchStore } from "@hospital/stores";
import { observer } from "mobx-react";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { UsersTable } from './UsersTable';



export interface IUserListContainerProps {
    scope: "all" | "org",
    organizationRelationKey: string | undefined;
    userStoreRef: React.RefCallback<UserSearchStore>
}


export const UserListContainer = observer(({ organizationRelationKey, userStoreRef, scope }: IUserListContainerProps) => {
    const { configuration } = useApp();
    const navigate = useNavigate();
    const [userSearchStore] = useState<UserSearchStore>(new UserSearchStore(
        scope === 'all' ? { scope } :
            {
                scope,
                organizationVersionId: configuration.currentCorpOrganization.organizationVersionId,
                organizationSourceId: configuration.currentCorpOrganization.organizationSourceId,
                organizationRelationKey: organizationRelationKey

            }));
    useEffect(() => {
        if (userStoreRef)
            userStoreRef(userSearchStore);
    }, [userSearchStore, userStoreRef])

    useEffect(() => {
        userSearchStore.search();
    }, [userSearchStore, userSearchStore.combinedSearchParams]);

    const clickHandler = useCallback((userId: number) => {
        navigate(userId.toString());
    }, [navigate])

    return (
        <PageCard>
            <UsersTable userSearchStore={userSearchStore} onClick={clickHandler} />
            {userSearchStore.hasMultiplePages &&
                <Pager
                    skip={userSearchStore.searchParams.skip}
                    totalItems={userSearchStore.searchResults.totalRecordCount}
                    pageSize={userSearchStore.searchParams.top}
                    onPageChange={userSearchStore.changePage} />
            }
        </PageCard>
    )
});
